<div class="card-shadow overflow-x-auto rounded-xl border border-base-200">
  <table class="table table-fixed w-full" [class.!border-t-0]="!options()?.header?.show">
    <thead>
      <tr class="bg-base-200/30">
        @for (column of columns(); track column.field) {
          @let isOpenMenu =
            !column?.filter?.disabled &&
            showHeaderOption() &&
            column?.field !== 'rowNumber' &&
            column?.field !== 'checkbox';

          <th
            gridColumn
            [(align)]="align"
            [(orderBy)]="orderBy"
            [(selecteds)]="selecteds"
            [column]="column"
            [showHeaderOption]="showHeaderOption()"
            [class.open-menu]="isOpenMenu"
            class="border-0 text-xs font-medium text-base-content/35 uppercase tracking-wider"
            [ngClass]="[column.type === 'checkbox' ? 'left-0 sticky z-10' : '', column.style?.columnClass || '']"></th>
        }
      </tr>
    </thead>
    <tbody
      cdkDropList
      [cdkDropListDisabled]="!dragDropEnabled"
      (cdkDropListDropped)="onDrop($event)"
    >
      @for (row of rowData(); track row.uniqueId) {
        <tr
          cdkDrag
          [cdkDragDisabled]="!dragDropEnabled"
          animate.enter="fade-in"
          gridRow
          class="hover:bg-base-200/50 transition-colors"
          [class.cursor-pointer]="options()?.row?.clickHandler"
          [columns]="columns()!"
          [row]="row"
          [(selecteds)]="selecteds"></tr>
      } @empty {
        <tr>
          <td [attr.colspan]="columns().length" class="text-center border-0!">
            <div class="flex flex-col items-center justify-center min-h-[200px] gap-4">
              <div class="w-14 h-14 rounded-full bg-base-200/60 flex items-center justify-center">
                <span class="icon-[mdi--database-search-outline] text-2xl text-base-content/25"></span>
              </div>
              <div class="flex flex-col items-center gap-1">
                <p class="text-sm font-medium text-base-content/40">데이터가 없습니다</p>
                <p class="text-xs text-base-content/25">검색 조건을 변경하거나 새 항목을 등록해주세요.</p>
              </div>
            </div>
          </td>
        </tr>
      }
    </tbody>
  </table>
</div>
